export default "__VITE_ASSET__e2420286__"